export default __webpack_public_path__ + "static/Connie-2fa1e3ed96cb0efd055555b552d99b6e.png";